import { render, staticRenderFns } from "./ConfigCollapseItem.vue?vue&type=template&id=1fa81b82&"
import script from "./ConfigCollapseItem.vue?vue&type=script&lang=js&"
export * from "./ConfigCollapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports